import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Button } from "components/atoms/button/index";
import { Fields } from "./constants";
import { Header } from "components/atoms/header/index";
import * as S from "./forgot-password.styles";
import { Field } from "components/molecules/Field";
import { UserService } from "core/service/user.service";

export const ForgotPassword = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const onSubmit = (values) => {
    UserService.forgotpassword(values);
  };

  return (
    <div>
      <Header company="simpletax" />
      <S.Container>
        <S.CardHeader>{t("forgotpassword.header")}</S.CardHeader>
        <S.CardBody>
          <S.Form onSubmit={handleSubmit(onSubmit)}>
            {Fields.map((obj, index) => (
              <Field
                background="grey"
                labelcolor="light"
                {...obj}
                register={register}
                error={errors[obj.name]?.message}
                key={index}
              />
            ))}
            {/* todo: playstore and appstore link to be included */}
            <S.ButtonContianer>
              <Button value={t("forgotpassword.button")} />
            </S.ButtonContianer>
          </S.Form>
        </S.CardBody>
        <S.CardFooter>
          <S.RegisterWrap>
            <Link to="/">{t("forgotpassword.footer")}</Link>
          </S.RegisterWrap>
        </S.CardFooter>
      </S.Container>
    </div>
  );
};
